import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import ModalDialog from '../Dialog/ModalDialog';
import { EvoraTabs, TabCanvas } from '../Tabs/Tabs';
import ScreenDef from './Components/ScreenDef';
import Screen from './Components/Screen';

const TAB_CONFIG = {
    0: { key: 'definition', maxWidth: 'sm' },
    1: { key: 'security', maxWidth: 'md' }
};

const Settings = ({ open, toggleDialog }) => {
    const { t } = useTranslation();
    const [tabKey, setTabKey] = useState(0);
    const [settings, setSettings] = useState({
        general: {},
        security: {}
    });

    const tabLabels = Object.values(TAB_CONFIG).map(({ key }) => ({
        name: t(key),
        disabled: false
    }));

    const loadRecord = useCallback(async () => {
        const { data } = await axios.post('/int/screensettings', {
            path: window.location.hash
        });
        setSettings(data);
    }, []);

    useEffect(() => {
        if (open) loadRecord();
    }, [open, loadRecord]);

    const handleClose = useCallback(() => {
        toggleDialog();
    }, [toggleDialog]);

    const screenName = settings.general?.name || '';

    return (
        <ModalDialog
            title={`${screenName} ${t('settings')}`}
            toggleDialog={handleClose}
            dialogStatus={open}
            fullWidth
            maxWidth={TAB_CONFIG[tabKey].maxWidth}
        >
            <EvoraTabs
                tabLabels={tabLabels}
                tabKey={tabKey}
                changeTab={(_, newValue) => setTabKey(newValue)}
            />
            <TabCanvas value={tabKey} index={0}>
                <ScreenDef
                    settingsData={settings.general}
                    callBack={loadRecord}
                    toggleDialog={handleClose}
                />
            </TabCanvas>
            <TabCanvas value={tabKey} index={1}>
                <Screen
                    settingsData={settings.security}
                    callBack={loadRecord}
                    toggleDialog={handleClose}
                />
            </TabCanvas>
        </ModalDialog>
    );
};

export default Settings;